import { z } from "zod";

export const AGENT_WORKFLOW_RUN_WAIT_TIMER_STATUS_VALUES = [
  "WAITING",
  "COMPLETED",
  "CANCELLED",
] as const;

export const AgentWorkflowRunWaitTimerStatusEnum = z.enum(
  AGENT_WORKFLOW_RUN_WAIT_TIMER_STATUS_VALUES,
);

export type AgentWorkflowRunWaitTimerStatus = z.infer<
  typeof AgentWorkflowRunWaitTimerStatusEnum
>;

export const AGENT_WORKFLOW_RUN_WAIT_TIMER_STATUS =
  AgentWorkflowRunWaitTimerStatusEnum.enum;
